import { render } from "./BaseCalendar.vue?vue&type=template&id=9b54173e"
import script from "./BaseCalendar.vue?vue&type=script&lang=js"
export * from "./BaseCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__